import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useMsal } from '@azure/msal-react';
import { MOCK_AUTH_ENABLED } from '../../lib/constants';

export function LoginCallback() {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (MOCK_AUTH_ENABLED) {
      navigate('/', { replace: true });
      return;
    }

    instance
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          navigate('/', { replace: true });
        }
      })
      .catch((error) => {
        console.error('Login callback error:', error);
        navigate('/login', { replace: true });
      });
  }, [instance, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-surface-dark">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-3 border-brand border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-400 text-sm">Completing sign in...</p>
      </div>
    </div>
  );
}
